import { ComponentRef, Directive, Input, OnChanges, ViewContainerRef, inject } from '@angular/core';

import { NoPermissionComponent } from '../components/widgets/no-permission/no-permission.component';
import { DashboardCardModel } from '../models/dashboard-card.model';
import { DashboardComponentTypeEnum } from '../models/enums/dashboard-component.enum';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[slDashboardItem]',
    standalone: false
})
export class DashboardItemDirective implements OnChanges {
    @Input() card: DashboardCardModel;

    component: ComponentRef<any>;

    private readonly viewContainerRef = inject(ViewContainerRef);
    private readonly authService = inject(AuthService);

    ngOnChanges(): void {
        if (!!this.card) {
            const hasPermission = this.authService.hasPermission(this.card.commandName);
            const displayedComponent = hasPermission ? this.card.component : NoPermissionComponent;
            this.component = this.viewContainerRef.createComponent(displayedComponent);

            // The markdown component saves it's data and needs to be passed an id
            // to save and load the content
            if (this.card.type === DashboardComponentTypeEnum.Markdown) {
                this.component.instance.id = this.card.id;
            }
        }
    }
}
